import AccountCircleIcon from '@mui/icons-material/AccountCircle'
import AssessmentIcon from '@mui/icons-material/Assessment'
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer'
import { Grid, Stack, Step, StepIconProps, StepLabel, Stepper } from "@mui/material"
import { Notification } from 'Components/Notification'
import { useAppDispatch } from 'helpers/hooks'
import { useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { ShPaper } from 'shared/SharedStyles/ShSurfaces'
import { setAppContext } from 'store/slices/auth-v2/auth-v2-slice'
import { ShStepperConnector, ShStepperIconRoot } from './ApplyJob.styled'
import { ApplyJobSteps } from './ApplyJobConstants'
import { TCurrentJobApplyStep } from './ApplyJobModel'
import { JobDetailsPanel } from './JobDetailsPanel'

export const ApplyJobWrapper = () => {
    const dispatch = useAppDispatch();
    const [applyJobCurrentStep, setApplyJobCurrentStep] = useState<number>(0);
    const activeStep = useLocation().pathname.split("/").pop() as TCurrentJobApplyStep;

    const ShStepperIcon = (props: StepIconProps) => {
        const { active, completed, className } = props;

        const icons: { [index: string]: React.ReactElement } = {
            1: <AccountCircleIcon />,
            2: <QuestionAnswerIcon />,
            3: <AssessmentIcon />
        };

        return (
            <ShStepperIconRoot ownerState={{ completed, active }} className={className}>
                {icons[String(props.icon)]}</ShStepperIconRoot>
        );
    }

    // set app context
    useEffect(() => {
        dispatch(setAppContext({ currentAppContext: 'candidate_apply_job' }));
    }, [dispatch]);

    // Set stepper value on path change.
    useEffect(() => {
        setApplyJobCurrentStep(ApplyJobSteps.find(step => step.path === activeStep)?.value ?? 0);
    }, [activeStep]);

    return (<>
        <Notification />
        <Grid container padding={1} spacing={1} height='100%'>
            <Grid item xs={12} sm={12} md={4} lg={3} xl={3}>
                <JobDetailsPanel />
            </Grid>
            <Grid item xs={12} sm={12} md={8} lg={9} xl={9}>
                <ShPaper variant='outlined'>
                    <Stack rowGap={{ xs: 1, sm: 2, md: 2, lg: 2 }} paddingX={{ xs: 2, sm: 3, md: 4, lg: 4 }}
                        paddingTop={{ xs: 2, sm: 3, md: 4, lg: 4 }} paddingBottom={1}>
                        <Stepper activeStep={applyJobCurrentStep} alternativeLabel connector={<ShStepperConnector />}>
                            {ApplyJobSteps.map((step) => (
                                <Step key={step.value}>
                                    <StepLabel StepIconComponent={ShStepperIcon}>{step.label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                        <Outlet />
                    </Stack>
                </ShPaper>
            </Grid>
        </Grid>
    </>)
}